import { Convention } from "../../../concepts/objects";
import { HasWH } from "../../../platform/geom/Point";
import { Physical } from "./Physical";

export const Resizable = new Convention<Resizable>('Resizable');

export interface Resizable extends Physical {

    readonly width: number;

    readonly height: number;

    resize(width: number, height: number): this;
    resize(size: Partial<HasWH>): this;
}
